import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: ', 'px auto;\n  text-align: center;\n  width: ', 'px;\n'], ['\n  margin: ', 'px auto;\n  text-align: center;\n  width: ', 'px;\n']);

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';

var verticalMarginSize = gridSize() * 6;

var columnWidth = gridSize() * 8;
var gutter = gridSize() * 2;

var wideContainerWidth = columnWidth * 6 + gutter * 5;
var narrowContainerWidth = columnWidth * 4 + gutter * 3;

var Container = styled.div(_templateObject, verticalMarginSize, function (props) {
  return props.size === 'narrow' ? narrowContainerWidth : wideContainerWidth;
});

export default Container;